import React, { ReactElement } from 'react'
import { ProgramDetailsPage } from 'src/ui/page/es/program/details/ProgramDetailsPage'

export const ProgramEditPage = (): ReactElement => {
  return <ProgramDetailsPage mode="edit" />
}
